export default {
  //设置页面header标题
  setTitle(state, data) {
    state.title = data;
  },
  // 设置弹窗
  setDialog(state, data) {
    state.type = data.type;
    state.message = data.message;
    state.callback = data.callback;
  },
  // 清空弹窗
  clearDialog(state) {
    state.type = null;
    state.message = null;
    state.callback = null;
  },
  // 更新请求loading
  updateHttpLoading(state, data) {
    state.httpLoading = data
  },
  updateRouter(state, data) {
    switch (data.type) {
      case 'add':
        state.router.push(data.data);
        break;
      case 'del':
        state.router = state.router.filter(item => {
          return item !== data.data
        });
        break;
      case 'delAll':
        state.router = [];
        break;
      default:
        state.router = state.router;
    }
  },
  // 微信签名配置
  updateWxSignature(state, data) {
    state.signature = data
  },
  // 设置平台
  setPlatform(state, data) {
    state.platform = data
  },
  // 设置推荐人id
  setUserId(state, data) {
    state.user_id = data
  },
}



// WEBPACK FOOTER //
// ./src/store/system/mutations.js